import * as apiClient from './api.client';

let mfaClient = (function() {
    function checkStatus(response) {
        if (response.status < 200 || response.status > 300) {
            let error = new Error('Something went wrong with MFA client');
            error.response = response;
            error.status = response.status;
            throw error;
        }
        return response;
    }

    function parseJson(response) {
        return response.json();
    }

    function getResponseBody(requestPromise) {
        return requestPromise
            .then(checkStatus)
            .then(parseJson)
            .then(function(data) {
                return data;
            }).catch(function(error) {
                throw error;
            });
    }

    let shouldChallenge = function(devices) {
        if (!devices || !Array.isArray(devices)) {
            return Promise.reject('error');
        }
        let riskDevices = JSON.parse(JSON.stringify(devices));
        if (devices.length !== 0 && !riskDevices.every((currentValue) => (
            typeof currentValue === 'object'
            && currentValue.hasOwnProperty('type')
        ))) {
            return Promise.reject('error');
        }

        let payload = {
            'devices': riskDevices
        };
        return getResponseBody(apiClient.apiPost('/auth/mfa/v1/shouldChallenge', payload));
    };

    let getPhones = function(challengeTicket) {
        if (!challengeTicket) {
            return Promise.reject('error');
        }
        return getResponseBody(apiClient.apiPost('/auth/mfa/v1/2fa/get', challengeTicket));
    };

    let challenge = function(challengeTicket, sendType, phone) {
        let challengePayload = {
            'userUuid': null,
            'jwtId': null,
            'siteName': null,
            'locale': null,
            challengeTicket,
            sendType,
            phone
        };
        return getResponseBody(apiClient.apiPost('/auth/mfa/v1/2fa/challenge', challengePayload));
    };

    let verify = function(challengeTicket, userProvidedVerifyCode) {
        let verifyPayload = {
            'userUuid': null,
            'jwtId': null,
            'tgtId': null,
            challengeTicket,
            code: userProvidedVerifyCode
        };
        return getResponseBody(apiClient.apiPost('/auth/mfa/v1/2fa/verify', verifyPayload));
    };

    return {
        shouldChallenge,
        getPhones,
        challenge,
        verify
    };
}());

export default mfaClient;


